import { render, staticRenderFns } from "./TemplateChartsArea.vue?vue&type=template&id=dbef51f8&scoped=true"
import script from "./TemplateChartsArea.vue?vue&type=script&lang=js"
export * from "./TemplateChartsArea.vue?vue&type=script&lang=js"
import style0 from "./TemplateChartsArea.vue?vue&type=style&index=0&id=dbef51f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbef51f8",
  null
  
)

export default component.exports